import styled from 'styled-components';

export const DropdownContainer = styled.ul`
  position: absolute;
  z-index: 1;
  bottom: 0;
  transform: translateY(100%);
  right: 0;
  
  display: block;
  
  white-space: nowrap;
  
  background-color: ${({ theme }) => theme.white};
  box-shadow: 0 12px 48px rgba(0,0,0,0.1);
  border-radius: 6px;
  overflow: hidden;
`;

export const DropdownOption = styled.button`
  width: 100%;
  margin: 0;
  padding: 10px;
  
  font-size: 14px;
  color: ${({ theme, isActive }) => isActive ? theme.blue : theme.black};
  text-align: left;
  
  background-color: transparent;
  border: none;
  outline: none;
  
  cursor: pointer;
  transition: background-color 0.3s;
  
  &:hover {
    background-color: #f8f8f8;
  }
`;
